export const messages = {
  labels: {
    trialName: {
      id: 'treatmentSummary.Groups.HormoneTherapy.TrialName',
      defaultMessage: 'Regimen: ',
    },
    startDate: {
      id: 'treatmentSummary.Groups.HormoneTherapy.StartDate',
      defaultMessage: 'Start: ',
    },
    mostRecentTreatmentDate: {
      id: 'treatmentSummary.Groups.HormoneTherapy.MostRecentTreatmentDate',
      defaultMessage: 'Most Recent Treatment Date: ',
    },
    endDate: {
      id: 'treatmentSummary.Groups.HormoneTherapy.EndDate',
      defaultMessage: 'End: ',
    },
    doseAmount: {
      id: 'treatmentSummary.Groups.HormoneTherapy.DoseAmount',
      defaultMessage: 'Cumulative Dose: ',
    },
    plannedDuration: {
      id: 'treatmentSummary.Groups.HormoneTherapy.PlannedDuration',
      defaultMessage: 'Planned Duration: ',
    },
    frequency: {
      id: 'treatmentSummary.Groups.HormoneTherapy.Frequency',
      defaultMessage: 'Frequency: ',
    },
    provider: {
      id: 'treatmentSummary.Groups.HormoneTherapy.Provider',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.HormoneTherapy.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.HormoneTherapy.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.HormoneTherapy.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    dosageForm: {
      id: 'treatmentSummary.Groups.HormoneTherapy.DosageForm',
      defaultMessage: 'Form: ',
    },
    drugCategory: {
      id: 'treatmentSummary.Groups.HormoneTherapy.DrugCategory',
      defaultMessage: 'Drug Category: ',
    },
    route: {
      id: 'treatmentSummary.Groups.HormoneTherapy.Route',
      defaultMessage: 'Route: ',
    },
    trialIndicator: {
      id: 'treatmentSummary.Groups.HormoneTherapy.TrialIndicator',
      defaultMessage: 'Part of Trial?: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.HormoneTherapy.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
